import React from 'react';
import TablaImpuestopro from '../components/impuestoprodu/tablaIpmpro';

function Impuestopro() {

  return (
      <div className='col-12 d-flex justify-content-center row'>
        <TablaImpuestopro />
      </div>
  );
  
}

export default Impuestopro;




// WEBPACK FOOTER //
// ./src/pages/impuestoproduccion.js